/**
 * These uniquely identify requests we make with React-Query. Make a new one for each unique query.
 *
 * Simple Find should be reused for "find all". This way we can easily invalidate all queries or a specific one
 */
export enum QueryKeys {
    FIND_ACQUISITION_MODES = "FIND_ACQUISITION_MODES",
    FIND_ACQUISITION_MODES_FOR_FLIGHT_PLAN = "FIND_ACQUISITION_MODES_FOR_FLIGHT_PLAN",
    FIND_ACQUISITION_MODES_AOI_SPECS = "FIND_ACQUISITION_MODES_AOI_SPECS",
    FIND_REVIEW_STATUS_BY_PROJECT = "FIND_REVIEW_STATUS_BY_PROJECT",
    FIND_EMPLOYEE_LIST = "FIND_EMPLOYEE_LIST",
    FIND_EMPLOYEE_LIST_BY_PROJECT = "FIND_EMPLOYEE_LIST_BY_PROJECT",
    FIND_MISSION_SHIPMENT_INFO = "FIND_MISSION_SHIPMENT_INFO",
    FIND_DATA_RECEIPT = "FIND_DATA_RECEIPT",
    FIND_SENSOR_LIST = "FIND_SENSOR_LIST",
    // Also find all
    FIND_PROJECT = "FIND_PROJECT",
    FIND_NON_ACQUISITION_PROJECT = "FIND_NON_ACQUISITION_PROJECT",
    FIND_PROJECT_AOI = "FIND_PROJECT_AOI",
    FIND_SENSOR_INSTALLATIONS = "FIND_SENSOR_INSTALLATIONS",
    FIND_SENSORS = "FIND_SENSORS",
    FIND_ONE_SENSOR = "FIND_ONE_SENSOR",
}
